import { useEffect, useState } from "react";
import { CAP } from "../../../helpers/interfaces";
import { FormEditMode } from "../../../helpers/constants";
import { showConfirmBox } from "../../../helpers/utils";
import { deleteGTBClassification as deleteCAP } from "../../../apiServices/GTBMappingKeysApi";
import { Button, Grid, MenuItem, Pagination, Stack, Table, TableBody, TableHead } from "@mui/material";
import { CustomTextField, StyledTableCell, StyledTableRow } from "../../../layouts/themes";
import { Add, Delete, Edit } from "@mui/icons-material";
import CreateEditCAP from "./CreateEditCAP";




interface Props {
    cap: CAP[]
    setCAP: React.Dispatch<React.SetStateAction<CAP[]>>
}
function CAPList(props: Props) {

    const [filteredCAP, setFilteredCAP] = useState<CAP[]>([])
    const [searchQuery, setSearchQuery] = useState<string>("");
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [recordsPerPage, setRecordsPerPage] = useState<number>(5);
    const [numOfPages, setNumOfPages] = useState<number>(0);
    const [currentPageRecords, setCurrentPageRecords] = useState<CAP[]>([])
    const [openCAPForm, setOpenCAPForm] = useState(false);
    const [capEditMode, setCAPEditMode] = useState(FormEditMode.CREATE);
    const [capToEdit, setCAPToEdit] = useState<string>("");
    useEffect(() => {
        setFilteredCAP(props.cap.filter(e =>
            (searchQuery === "" || e.code.toLowerCase().includes(searchQuery.toLowerCase()))
        ));
        setCurrentPage(1);
    }, [searchQuery, props.cap])

    useEffect(() => {
        setNumOfPages(Math.ceil(filteredCAP.length / recordsPerPage))
    }, [recordsPerPage, filteredCAP])

    useEffect(() => {
        const lastIndex = currentPage * recordsPerPage;
        const firstIndex = lastIndex - recordsPerPage;
        setCurrentPageRecords(filteredCAP.slice(firstIndex, lastIndex))
    }, [currentPage, recordsPerPage, filteredCAP])

    function handleCAPForm() {
        setCAPEditMode(FormEditMode.CREATE);
        setOpenCAPForm(true);
    }

    const handleEdit = (cap: CAP) => {
        setCAPToEdit(cap.id)
        setCAPEditMode(FormEditMode.EDIT);
        setOpenCAPForm(true);
    }
    const handleDeleteCAP = (id: string) => {
        showConfirmBox("Are you sure you want to Delete this CAP?", " Delete CAP")
            .then((result) => {
                if (result.isConfirmed)
                    deleteCAP(id).then(() => props.setCAP(s => s.filter(u => u.id !== id)))
            })
    }
    return (
        <>
            <div className=" flex flex-row ">
                <div className=' flex w-2/3 '>
                    <CustomTextField size="small" id="outlined-basic" placeholder="Search by name..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} variant="outlined" sx={{ width: '50%' }} /> &nbsp;

                </div>
                <div style={{ flexGrow: 1 }} />

                <Button color='secondary' variant="contained" style={{ textTransform: 'none', fontSize: 14, }} onClick={handleCAPForm}><Add />&nbsp; Create New CAP</Button>
            </div>
            <br />
            <div className="relative overflow-x-auto ">
                <Table>
                    <TableHead>
                        <StyledTableRow>
                            <StyledTableCell> SN</StyledTableCell>
                            <StyledTableCell>Code</StyledTableCell>
                            <StyledTableCell>Description</StyledTableCell>
                            <StyledTableCell  ><div style={{ float: 'right' }}>Action</div></StyledTableCell>
                        </StyledTableRow>
                    </TableHead>
                    <TableBody>
                        {currentPageRecords.map((item, index) => {
                            return <StyledTableRow key={index}>

                                <StyledTableCell>{index + 1 + ((currentPage - 1) * recordsPerPage)}</StyledTableCell>
                                <StyledTableCell >{item.code}</StyledTableCell>
                                <StyledTableCell >{item.description}</StyledTableCell>
                                <StyledTableCell >
                                    <div style={{ float: 'right' }}>
                                        <Button variant='outlined' color='info' size='small' onClick={() => { handleEdit(item) }}  ><Edit />&nbsp; Edit</Button>&nbsp;&nbsp;&nbsp;&nbsp;
                                        <Button variant='outlined' color='secondary' size='small' onClick={() => { handleDeleteCAP(item.id) }} ><Delete />&nbsp;Delete</Button>
                                    </div>

                                </StyledTableCell>
                            </StyledTableRow>
                        })}

                        {currentPageRecords.length === 0 &&
                            <tr>
                                <StyledTableCell colSpan={4}><p style={{ fontSize: '11px', textAlign: 'center' }}>No record available...</p></StyledTableCell>
                            </tr>
                        }
                    </TableBody>
                </Table>
            </div>

            <br />

            <nav>
                <div className=" flex flex-row ">
                    <div className=" flex items-start ">
                        <div className="px-6 py-2">Rows per page</div>&nbsp;
                        < Grid item xs={12} lg={3} >
                            <CustomTextField fullWidth id="fullWidth" select variant="outlined" size="small" name="RequestsNumbers" value={recordsPerPage} onChange={(e) => setRecordsPerPage(Number(e.target.value))} >
                                <MenuItem value="5">5</MenuItem >
                                <MenuItem value="15">15</MenuItem >
                                <MenuItem value="25">25</MenuItem >
                                <MenuItem value="40">40</MenuItem >
                                <MenuItem value="55">55</MenuItem >
                                <MenuItem value="85">85</MenuItem >
                                <MenuItem value="125">125</MenuItem >
                                <MenuItem value="200">200</MenuItem >
                                <MenuItem value="255">255</MenuItem >
                                <MenuItem value="350">350</MenuItem >
                                <MenuItem value="500">500</MenuItem >


                            </CustomTextField>
                        </Grid>
                    </div>
                    <div style={{ flexGrow: 1 }} />
                    <Stack spacing={2}>
                        <Pagination color="secondary" count={numOfPages} siblingCount={1} boundaryCount={1}
                            onChange={(event, value) => setCurrentPage(value)} page={currentPage} size="small" classes={{ ul: "PaginationUl" }} />
                    </Stack>

                </div>
                <br />


            </nav>
            {openCAPForm &&
                <CreateEditCAP setFormEditMode={setCAPEditMode} capEditMode={capEditMode} setOpenCAPForm={setOpenCAPForm} openCAPForm={openCAPForm} cap ={props.cap} setCAP={props.setCAP} capToEdit={capToEdit} />
            }
        </>
    )
}
export default CAPList